<div class="divbox" [class.inline]="inline" fxLayoutAlign="center center">
  <mat-card class="box" [class.inline]="inline">
    <div >

      <div class="divtitle">
        <mat-card-title class="clstitle">
          <div class="title-grid">
            <div>
              {{titleConfiguration}}
            </div>
            <div class="device-status" *ngIf="item?.data?.current_device_state" fxLayoutAlign="end">
              {{'configuration.state' | transloco}}: {{item?.data?.current_device_state | deviceStatus}}
            </div>
          </div>
        </mat-card-title>
      </div>

      <div>
        <form method="post" class="form" #f="ngForm" (ngSubmit)="f.form.valid && onGuardarItm()" >
          <mat-card-content class="mat-elevation-z8">
            <mat-form-field class="full-width">
              <mat-label>{{'configuration.sn' | transloco}}</mat-label>
              <input matInput type="text" name="serial_number" placeholder="{{'configuration.sn' | transloco}}" [(ngModel)]="serial_number_Input" [readonly]="true">
              <mat-error>
                {{'configuration.errorMandatory' | transloco}}
              </mat-error>
            </mat-form-field>

            <div class="timing-fields">
              <mat-form-field>
                <mat-label>{{'configuration.actTimeDes' | transloco}}</mat-label>
                <input matInput type="number" name="desired_active_sampling_time" placeholder="{{'configuration.actTimeDes' | transloco}}" [(ngModel)]="desired_active_sampling_time_Input" required max="9999999">
                <mat-error>
                  {{'configuration.errorIncorrect' | transloco}}
                </mat-error>
              </mat-form-field>
  
              <mat-form-field>
                <mat-label>{{'configuration.actTimeEnv' | transloco}}</mat-label>
                <input matInput type="number" name="desired_active_sending_time" placeholder="{{'configuration.actTimeEnv' | transloco}}" [(ngModel)]="desired_active_sending_time_Input" required max="9999999">
                <mat-error>
                  {{'configuration.errorIncorrect' | transloco}}
                </mat-error>
              </mat-form-field>
  
            </div>

            <mat-form-field class="full-width">
              <mat-label>{{'configuration.desiredState' | transloco}}</mat-label>
              <mat-select [(value)]="desired_state_Selected"  [formControl]="stateControl" required>
                @for (itemState of lstConfigurationStates; track itemState) {
                  <mat-option [value]="itemState.value">{{itemState.viewValue}}</mat-option>
                }
              </mat-select>
              <mat-error>
                {{'configuration.errorIncorrect' | transloco}}
              </mat-error>
            </mat-form-field> 

            <mat-form-field class="full-width" *ngIf="isSuperAdmin">
              <mat-label>{{'configuration.update_name' | transloco}}</mat-label>
              <input matInput type="text" name="update_name" placeholder="{{'configuration.update_name' | transloco}}" [(ngModel)]="update_name_Input">
              <mat-error>
                {{'configuration.errorIncorrect' | transloco}}
              </mat-error>
            </mat-form-field>

          </mat-card-content>

          <div class="configuration-footer">
            <p class="firmware">
              {{'configuration.currentFirmware' | transloco}}:
              {{item?.data?.current_firmware_name}}
            </p>
            <div class="configuration-actions">
              <button class="settings-action" mat-flat-button color="primary" *ngIf="role<3" type="submit"><mat-icon>save</mat-icon>{{'configuration.save' | transloco}}</button>
              <button *ngIf="!inline" mat-stroked-button [mat-dialog-close]="false">{{'configuration.cancel' | transloco}}</button>
            </div>
          </div>
        </form>
      </div>

  </div>
  </mat-card>
</div>
